import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CONSTANTS } from 'common/constants';
import { getLicenceList, getLicences, getOnGoingCases } from 'store/api/dashboard.api';

interface IState {
    cases: { [key: string]: string }[];
    completedLicences: { [key: string]: string }[];
    completedLicencesStatus: string;
    licences: { [key: string]: string }[];
    lincenceStatus: string;
    type: string;
    status: string;
    tab: number;
    mainTab: number;
    licenceTab: number;
    isFromNotification: boolean;
    selectedCaseID: string;
    querySearchMode: boolean;
    appealFeeAmount: string;
}

const initialState: IState = {
    cases: [],
    licences: [],
    completedLicences: [],
    status: CONSTANTS.IDLE,
    lincenceStatus: CONSTANTS.IDLE,
    completedLicencesStatus: CONSTANTS.IDLE,
    type: '',
    tab: 0,
    mainTab: 0,
    licenceTab: 0,
    isFromNotification: false,
    selectedCaseID: '',
    querySearchMode: false,
    appealFeeAmount: ''
};
export interface caseType {
    [key: string]: string;
}
export const getNewCase = createAsyncThunk('dashboard/getCase', async (_, { getState }) => {
    const { account } = getState() as { account: any };
    const cases: { [key: string]: string }[] = await getOnGoingCases(account?.user?.uen || account?.user?.id);
    return cases;
});

export const getNewLicenceList = createAsyncThunk('dashboard/getLicenceList', async (_, { getState }) => {
    const { account } = getState() as { account: any };
    try {
        const cases: { [key: string]: string }[] = await getLicenceList(account?.user?.uen || account?.user?.id || 'S6005048A');
        return cases;
    } catch (error) {
        return [];
    }
});

export const getNewLicence = createAsyncThunk('dashboard/getLicence', async (_, { getState }) => {
    const { account } = getState() as { account: any };
    try {
        const cases: { [key: string]: string }[] = await getLicences(account?.user?.uen || account?.user?.id || 'S6005048A');
        return cases;
    } catch (error) {
        return [];
    }
});

export const getNewLicenceBySearchQuery = createAsyncThunk('dashboard/getLicence', async (searchQuery: string, { getState }) => {
    const { account } = getState() as { account: any };
    try {
        const cases: { [key: string]: string }[] = await getLicences(account?.user?.uen || account?.user?.id || 'S6005048A', searchQuery);
        return cases;
    } catch (error) {
        return [];
    }
});

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        removeEvent(state, action) {
            state.cases = state.cases.filter((value: { [key: string]: string }) => value.pzInsKey !== action.payload);
        },
        removeMessage(state, action) {
            const tempCase = [...state.cases];
            const findCase = tempCase.find((value) => value.pzInsKey === action.payload);
            const findIndex = tempCase.findIndex((value) => value.pzInsKey === action.payload);
            if (findCase) {
                findCase.UnreadCount = '0';
                tempCase[findIndex] = findCase;
                state.cases = tempCase;
            }
        },
        addWishToProvidePerformersList(state, action) {
            const tempCase = [...state.cases];
            const findCase = tempCase.find((value) => value.pzInsKey === action.payload);
            const findIndex = tempCase.findIndex((value) => value.pzInsKey === action.payload);
            if (findCase) {
                findCase.WishToProvidePerformersList = 'Yes';
                tempCase[findIndex] = findCase;
                state.cases = tempCase;
            }
        },
        addKDM(state, action) {
            const tempCase = [...state.cases];
            const findCase = tempCase.find((value) => value.pzInsKey === action.payload);
            const findIndex = tempCase.findIndex((value) => value.pzInsKey === action.payload);
            if (findCase) {
                findCase.IsPendingKDM = 'false';
                tempCase[findIndex] = findCase;
                state.cases = tempCase;
            }
        },
        pendingAdditionalInformation(state, action) {
            const tempCase = [...state.cases];
            const findCase = tempCase.find((value) => value.pzInsKey === action.payload);
            const findIndex = tempCase.findIndex((value) => value.pzInsKey === action.payload);
            if (findCase) {
                tempCase[findIndex] = findCase;
                state.cases = tempCase;
            }
        },
        addPELicenceNo(state, action) {
            const tempCase = [...state.cases];
            const findCase = tempCase.find((value) => value.pzInsKey === action.payload);
            const findIndex = tempCase.findIndex((value) => value.pzInsKey === action.payload);
            if (findCase) {
                findCase.PELicenceNo = 'L/PE/XXXXXX/XXXX';
                tempCase[findIndex] = findCase;
                state.cases = tempCase;
            }
        },
        addType(state, action) {
            state.type = action.payload;
        },
        setTab(state, action) {
            state.tab = action.payload;
        },
        setMainTab(state, action) {
            state.mainTab = action.payload;
        },
        resetDashboard(state) {
            state.cases = [];
            state.type = '';
            state.tab = 0;
            state.status = CONSTANTS.IDLE;
        },
        setNotification(state, action) {
            state.isFromNotification = action.payload;
        },
        setLicenceTab(state, action) {
            state.licenceTab = action.payload;
        },
        resetLicence(state) {
            state.licences = [];
            state.type = '';
            state.licenceTab = 0;
            state.lincenceStatus = CONSTANTS.IDLE;
            state.completedLicences = [];
            state.completedLicencesStatus = CONSTANTS.IDLE;
        },
        setSelectedCaseID(state, action) {
            state.selectedCaseID = action.payload;
        },
        setQuerySearchMode(state, action) {
            state.querySearchMode = action.payload;
        },
        setAppealAmount(state, action) {
            state.appealFeeAmount = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNewCase.fulfilled, (state, action) => {
                if (action.payload) {
                    state.cases = action.payload!;
                }
                state.status = CONSTANTS.FULFILLED;
            })
            .addCase(getNewCase.pending, (state) => {
                state.status = CONSTANTS.LOADING;
            })
            .addCase(getNewCase.rejected, (state) => {
                state.status = CONSTANTS.FAILED;
            });
        builder
            .addCase(getNewLicence.fulfilled, (state, action) => {
                state.licences = action.payload!;
                state.lincenceStatus = CONSTANTS.FULFILLED;
            })
            .addCase(getNewLicence.pending, (state) => {
                state.lincenceStatus = CONSTANTS.LOADING;
            });
        builder
            .addCase(getNewLicenceList.fulfilled, (state, action) => {
                state.completedLicences = action.payload!;
                state.completedLicencesStatus = CONSTANTS.FULFILLED;
            })
            .addCase(getNewLicenceList.pending, (state) => {
                state.completedLicencesStatus = CONSTANTS.LOADING;
            });
    }
});

export const {
    addWishToProvidePerformersList,
    addPELicenceNo,
    removeEvent,
    addType,
    setTab,
    resetDashboard,
    removeMessage,
    setNotification,
    setMainTab,
    setLicenceTab,
    resetLicence,
    setSelectedCaseID,
    setQuerySearchMode,
    addKDM,
    pendingAdditionalInformation,
    setAppealAmount
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
